import type {
    BeginCommerceQuickBuyRequest,
    BeginCommerceQuickBuyResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";

export const beginCommerceQuickBuyOperation = defineCommerceOperation<
    BeginCommerceQuickBuyRequest,
    BeginCommerceQuickBuyResponse
>("commerce.checkout.quick-buy.begin");
